// extracted by mini-css-extract-plugin
var _1 = "SVGIcon-module__icon--fV131";
var _2 = "SVGIcon-module__inline--myTLc";
var _3 = "SVGIcon-module__large--Rjtub";
var _4 = "SVGIcon-module__small--NRrGa";
export { _1 as "icon", _2 as "inline", _3 as "large", _4 as "small" }
